import React from "react"
import { AiOutlineSearch } from "react-icons/ai"
import { Link } from "react-router-dom"
import useGlobalContext from "../context/GlobalContext"

const Menu = () => {
  const { small, showMenu } = useGlobalContext()

  return (
    <div
      className={`menu-container ${small ? "scrolled" : ""} ${
        showMenu ? "show" : ""
      }`}
    >
      <div className="wrapper">
        <div className="menu-wrapper">
          <div className="newsletter menu-newsletter">
            <p className="title-xs">search</p>
            <form className="newsletter-form">
              <input
                required
                type="text"
                placeholder="search anything"
                id="search"
                name="search"
              />
              <button type="submit" aria-label="Search">
                <AiOutlineSearch />
              </button>
            </form>
          </div>
          <ul className="menu-links menu-mobile-links">
            <p className="title-xs">explore</p>
            <li>
              <Link to="/">shop</Link>{" "}
            </li>
            <li>
              <Link to="/">culture</Link>
            </li>
            <li>
              <Link to="/">about</Link>
            </li>
          </ul>
          <ul className="menu-links">
            <p className="title-xs">account</p>
            <li tabIndex={0}>Login</li>
            <li tabIndex={0}>Signup</li>
          </ul>
        </div>
        <div className="menu-footer">
          <div className="menu-footer-links">
            <p className="title-xs">socials</p>
            <ul className="menu-links-flex">
              <li tabIndex={0}>Instagram</li>
              <li tabIndex={0}>Tiktok</li>
              <li tabIndex={0}>Youtube</li>
            </ul>
          </div>
          <p>© 2023 Dallol The Brand</p>
        </div>
      </div>
    </div>
  )
}

export default Menu
